type PortfolioImpactState = "danger" | "error" | "warning" | "success";

export const getPortfolioImpactState = (
  value: number,
): PortfolioImpactState => {
  if (value >= 0.9) return "danger";
  if (value >= 0.7) return "error";
  if (value >= 0.45) return "warning";
  return "success";
};
